import React from "react";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import dayjs from "dayjs";

interface UndertakingDoc {
  id: number;
  document_id: number;
  document_name: string;
  consent_text: string;
  document_type: string;
  created_at: string;
}

interface UndertakingListProps {
  underTacking: UndertakingDoc[];
}

const UndertakingDetailConsent: React.FC<UndertakingListProps> = ({
  underTacking,
}) => {
  return (
    <Box mt={2}>
      {underTacking?.map((doc, index) => (
        <Accordion key={doc.id} sx={{ mb: 1, borderRadius: '8px !important', overflow: 'hidden' }} variant="outlined">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel${doc.id}-content`}
            id={`panel${doc.id}-header`}
            sx={{
              borderBottom: '1px solid #cccc',
              px: 1,
              mb: 0,
              '& .MuiAccordionSummary-content.Mui-expanded': {
                margin: 0
              }
            }}
          >
            <Box display="flex" flexDirection="column" width={"100%"}>
              <Box display="flex" gap={1} alignItems="center" mb={1}>
                <CheckCircleOutlineOutlinedIcon color="success" />
                <Box>
                  <h4 className="body-m gray-900 font-medium">
                    {doc.document_name}
                  </h4>
                  <h5 className="gray-700 font-regular"> <em>Consent on: {dayjs(doc.created_at).format("DD MMMM YYYY, hh:mm:ssA")}</em> </h5>
                </Box>
              </Box>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className="body-m"  sx={{ whiteSpace: 'pre-line' }}>
              {doc.consent_text}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default UndertakingDetailConsent;